import React from 'react'
import withIcon from '@/components/withIcon'

const IconRoom = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13.957C10.6143 13.8692 11.2017 13.6469 11.7202 13.306C12.2388 12.9652 12.6757 12.5141 13 11.985V22.25C13.0008 22.5813 13.1327 22.8988 13.367 23.133C13.6012 23.3673 13.9187 23.4992 14.25 23.5H16.75C17.0813 23.4992 17.3988 23.3673 17.633 23.133C17.8673 22.8988 17.9992 22.5813 18 22.25V16.25C18 16.5815 18.1317 16.8995 18.3661 17.1339C18.6005 17.3683 18.9185 17.5 19.25 17.5C19.5815 17.5 19.8995 17.3683 20.1339 17.1339C20.3683 16.8995 20.5 16.5815 20.5 16.25V11.5C20.5 10.7044 20.1839 9.94129 19.6213 9.37868C19.0587 8.81607 18.2956 8.5 17.5 8.5H13.986C13.3821 8.5003 12.7901 8.66888 12.2767 8.98682C11.7632 9.30476 11.3485 9.7595 11.079 10.3L10.961 10.537C10.8156 10.8264 10.5926 11.0696 10.317 11.2397C10.0413 11.4097 9.72386 11.4998 9.4 11.5H4.75C4.41848 11.5 4.10054 11.6317 3.86612 11.8661C3.6317 12.1005 3.5 12.4185 3.5 12.75C3.5 13.0815 3.6317 13.3995 3.86612 13.6339C4.10054 13.8683 4.41848 14 4.75 14H6L10 13.957Z"
        fill="#C6D5D8"
      />
      <path
        d="M10 11.394V17C10 17.2653 9.89464 17.5196 9.70711 17.7072C9.51957 17.8947 9.26522 18 9 18H7C6.73478 18 6.48043 17.8947 6.29289 17.7072C6.10536 17.5196 6 17.2653 6 17V11.5"
        fill="white"
      />
      <path
        d="M10 11.394V17C10 17.2653 9.89464 17.5196 9.70711 17.7072C9.51957 17.8947 9.26522 18 9 18H7C6.73478 18 6.48043 17.8947 6.29289 17.7072C6.10536 17.5196 6 17.2653 6 17V11.5"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 16.5V12"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 23.5V17"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.957C10.6143 13.8692 11.2017 13.6469 11.7202 13.306C12.2388 12.9652 12.6757 12.5141 13 11.985V22.25C13.0008 22.5813 13.1327 22.8988 13.367 23.133C13.6012 23.3673 13.9187 23.4992 14.25 23.5H16.75C17.0813 23.4992 17.3988 23.3673 17.633 23.133C17.8673 22.8988 17.9992 22.5813 18 22.25V16.25C18 16.5815 18.1317 16.8995 18.3661 17.1339C18.6005 17.3683 18.9185 17.5 19.25 17.5C19.5815 17.5 19.8995 17.3683 20.1339 17.1339C20.3683 16.8995 20.5 16.5815 20.5 16.25V11.5C20.5 10.7044 20.1839 9.94129 19.6213 9.37868C19.0587 8.81607 18.2956 8.5 17.5 8.5H13.986C13.3821 8.5003 12.7901 8.66888 12.2767 8.98682C11.7632 9.30476 11.3485 9.7595 11.079 10.3L10.961 10.537C10.8156 10.8264 10.5926 11.0696 10.317 11.2397C10.0413 11.4097 9.72386 11.4998 9.4 11.5H4.75C4.41848 11.5 4.10054 11.6317 3.86612 11.8661C3.6317 12.1005 3.5 12.4185 3.5 12.75C3.5 13.0815 3.6317 13.3995 3.86612 13.6339C4.10054 13.8683 4.41848 14 4.75 14H6"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3.5V4C13 4.66304 13.2634 5.29893 13.7322 5.76777C14.2011 6.23661 14.837 6.5 15.5 6.5C16.163 6.5 16.7989 6.23661 17.2678 5.76777C17.7366 5.29893 18 4.66304 18 4V3.5H13Z"
        fill="#E4EBEC"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 3.50001H13V1.35501C12.9997 1.25025 13.0316 1.14794 13.0916 1.06204C13.1516 0.976132 13.2366 0.910819 13.335 0.875008C14.735 0.374997 16.265 0.374997 17.665 0.875008C17.7635 0.910819 17.8484 0.976132 17.9084 1.06204C17.9684 1.14794 18.0003 1.25025 18 1.35501V3.50001Z"
        fill="#C6D5D8"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default withIcon(IconRoom)
